import React, { useEffect, useState } from "react";
import { MenuOutlined } from "@ant-design/icons";
import Sidebar from "../components/Sidebar";
import "../styles/sidebar-responsive.scss";

interface MainLayoutProps {
  children: React.ReactNode;
  userRole: any;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, userRole }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Пока открыто мобильное меню, страница под ним не прокручивается.
  useEffect(() => {
    if (!mobileMenuOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);

  // На десктопе кнопка и оверлей меню скрыты, поэтому drawer нужно закрыть,
  // иначе body останется заблокированным без способа закрыть меню.
  useEffect(() => {
    const mql = window.matchMedia("(max-width: 767px)");
    const handleChange = (event: MediaQueryListEvent) => {
      if (!event.matches) setMobileMenuOpen(false);
    };

    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return (
    <div>
      {/*<Header />*/}
      <div className="h-screen bg-gray-50 px-20 pt-[120px]">
        <button
          type="button"
          className="mobile-menu-toggle"
          aria-label="menu"
          onClick={() => setMobileMenuOpen(true)}
        >
          <MenuOutlined />
        </button>

        <Sidebar
          userRole={userRole}
          mobileOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        />

        {mobileMenuOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => setMobileMenuOpen(false)}
          />
        )}

        <div className="flex main-layout-design">
          <div className="left-side" />
          <main className="right-side">{children}</main>
        </div>
        {/*<Footer />*/}
      </div>
    </div>
  );
};

export default MainLayout;
